export default __webpack_public_path__ + "static/media/guru-parampara-title-banner.8f06fba9.png";